import { type Address, erc20Abi, type WalletClient } from "viem";

import { errorMessages } from "#/config/errorMessages";

export const approveToken = async ({
  walletClient,
  tokenAddress,
  amount,
  spender,
}: {
  walletClient: WalletClient;
  tokenAddress: Address;
  amount: bigint;
  spender: Address;
}) => {
  if (!walletClient.account) {
    throw new Error(errorMessages.WALLET_CLIENT_UNAVAILABLE);
  }

  try {
    const hash = await walletClient.writeContract({
      account: walletClient.account,
      address: tokenAddress,
      abi: erc20Abi,
      functionName: "approve",
      args: [spender, amount],
      chain: walletClient.chain,
    });

    return hash;
  } catch (error) {
    console.error("Error approving token:", error);
    throw new Error("Token approval failed");
  }
};
